import React from "react";

import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import LockIcon from "@material-ui/icons/Lock";

import useStyles from "./useStyles";

const AssessmentCompletedBanner = () => {
  const classes = useStyles();
  return (
    <Grid container className={classes.wrapperContainer}>
      <Grid
        container
        lg={4}
        md={4}
        xs={12}
        sm={12}
        className={classes.leftContent}
      >
        <img
          className={classes.character2}
          src="/person.svg"
          alt="Character 2"
        />
        <Typography
          gutterBottom
          variant="p"
          component="div"
          className={[classes.top, classes.blue].join(" ")}
        >
          <LockIcon className={classes.large} />

          {` Safe.Secure.Trusted`}
        </Typography>
      </Grid>
      <Grid
        container
        lg={8}
        md={8}
        xs={12}
        sm={12}
        className={classes.rightContent}
      >
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          alignItems="stretch"
          justifyContent="spece-between"
          textAlign="center"
          height="auto"
        >
          <Box pb={2} width="100%">
            <Typography
              className={classes.completedTitle}
              variant="h5"
              align="center"
            >
              Congrats&#33; You&apos;ve successfully completed your Assessment
            </Typography>
          </Box>
          <Box pt={3} pb={3} width="100%">
            <Typography
              className={classes.completedBody}
              variant="body2"
              align="center"
            >
              To continue assisting you in your Financial education, we need you
              to set up your account password. Click on Set Up Account button,
              to continue with the next step.
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default AssessmentCompletedBanner;
